module.exports = __webpack_public_path__ + "dfd8db5fc65d49e7385b2e3fd9b1a98c.jpg";